import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class LogCleanerConfiguration extends PredefinedBaseConfiguration {
businessUnitCode: string;
domain: string;
exitStatusOnSuccess: boolean | null;
retentionPeriod: number | null;
visionCode: string;
}

